import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SessionHelper } from '@src/app/helpers/sessionHelper';
import { environment } from '@src/environments/environment';
import { Customer } from '../model/customer';

@Injectable({
  providedIn: 'root'
})
export class CustomernameService {

  constructor(private http:HttpClient) { }

  getCustomer(customerId:string,pit:String){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.get<Customer>(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/customer/'+customerId+'/pit/'+pit,httpOptions);
  }
}
